import { Divider } from '@neo4j-ndl/react';
import type { DbmsInfo } from '@nx/state/desktop';
import { DBMS_STATUS } from '@nx/state/desktop';
import { isNotNullish, isNullish } from '@nx/stdlib';
import { OpenPathIconButton } from '@nx/ui';
import { memo } from 'react';

import { InstanceCardWrapper } from '../../components/instance-card-wrappers';
import { DbmsStatusLabel } from '../entities/dbms-status-label';
import type { InstanceDetailsTab } from '../instance-details';
import { PropertyDisplay } from '../property-display';
import { DatabaseList } from './database-list';
import { InstanceCardHeaderWithControls } from './header';

interface InstanceCardProps {
  instance: DbmsInfo;
  onInstanceDetailsClick: (initialTab?: InstanceDetailsTab) => void;
  onConnectionSuccess?: () => void;
  isCompact?: boolean;
}

export const InstanceCardComponent = ({
  instance,
  onInstanceDetailsClick,
  onConnectionSuccess,
  isCompact = false,
}: InstanceCardProps) => {
  if (isNullish(instance)) {
    return null;
  }

  return (
    <InstanceCardWrapper isHighlighted={DBMS_STATUS.STARTED === instance.status}>
      <InstanceCardHeaderWithControls
        instance={instance}
        onInstanceDetailsClick={onInstanceDetailsClick}
        onConnectionSuccess={onConnectionSuccess}
        isCompact={isCompact}
      />
      <DbmsStatusLabel instance={instance} />
      <div className="flex flex-wrap items-center gap-2  py-3">
        <PropertyDisplay label="ID" text={instance.id} truncate allowCopyText />
        <Divider orientation="vertical" />
        {isNotNullish(instance.version) && <PropertyDisplay label="Version" text={instance.version} />}
        <Divider orientation="vertical" />
        {isNotNullish(instance.rootPath) && (
          <PropertyDisplay
            label="Path"
            text={instance.rootPath}
            truncate
            action={<OpenPathIconButton path={instance.rootPath} size="small" />}
          />
        )}
        <Divider orientation="vertical" />
        <PropertyDisplay label="Connection URI" text={instance.connectionUri} allowCopyText />
      </div>

      {!isCompact && (
        <div className="flex flex-col gap-2 pt-0">
          <DatabaseList instance={instance} />
        </div>
      )}
    </InstanceCardWrapper>
  );
};

export const InstanceCard = memo(InstanceCardComponent);
